"use client";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";

export default function Hero() {
  const { classes } = styles();

  return (
    <Box className={classes.container}>
      {/* Overlay for dark backdrop on mobile */}
      <Box className={classes.overlay} />

      <Box className={classes.heroText}>
        <Typography className={classes.hero}>
          Discover all services we offer
        </Typography>
        <Typography className={classes.content}>
          From property development to investment consulting, we provide
          high-quality real estate solutions designed to meet your needs
        </Typography>
      </Box>

      <Box className={classes.imgBox}>
        <Box className={classes.topBox}>
          <Box className={classes.imgCont}>
            <Image
              src={"/images/service/Frame.svg"}
              fill
              objectFit="cover"
              alt="service Image"
            />
          </Box>
          <Box className={classes.imgCont}>
            <Image
              src={"/images/service/Frame-1.svg"}
              fill
              objectFit="cover"
              alt="service Image"
            />
          </Box>
        </Box>
        <Box className={classes.bottomBox}>
          <Box className={classes.imgCont}>
            <Image
              src={"/images/service/Frame-2.svg"}
              fill
              objectFit="cover"
              alt="service Image"
            />
          </Box>
          <Box className={classes.imgCont}>
            <Image
              src={"/images/service/Frame-3.svg"}
              fill
              objectFit="cover"
              alt="service Image"
            />
          </Box>
          <Box className={classes.imgCont}>
            <Image
              src={"/images/service/Frame-4.svg"}
              fill
              objectFit="cover"
              alt="service Image"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    alignItems: "center",
    gap: theme.spacing(4),
    backgroundColor: AppColors.neutral["120"],
    minHeight: pxToRem(527),
    position: "relative",
    overflow: "hidden",

    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      padding: pxToRem(14),
    },
  },
  overlay: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.6)",

      zIndex: 1,
    },
  },
  heroText: {
    paddingLeft: pxToRem(100),
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      // paddingLeft: pxToRem(24),
      // paddingRight: pxToRem(24),
      // textAlign: "left",
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(0),
    },
  },
  hero: {
    fontFamily: "Playfair Display",
    fontSize: pxToRem(60),
    lineHeight: "120%",
    fontWeight: 700,
    color: AppColors.text.default,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(38),
      color: "#FFFFFF",
    },
  },
  content: {
    fontFamily: "General Sans",
    fontSize: pxToRem(20),
    lineHeight: "160%",
    fontWeight: 400,
    color: "#6A6A6A",
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(20),
      color: "#FFFFFF",
      textAlign: "left",
    },
  },
  imgBox: {
    height: "100%",
    display: "grid",
    gridTemplateRows: "1fr 1fr",
    zIndex: 0,
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  },
  topBox: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    height: "100%",
  },
  bottomBox: {
    display: "grid",
    gridTemplateColumns: "repeat(3,1fr)",
    height: "100%",
  },
  imgCont: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
}));
